"use client"

import { useState } from "react"
import Header from "../../components/protected/Header"
import ReactPaginate from "react-paginate"
import Footer from "../../components/footer"
import Words from "../../components/protected/words/Words"
import { useTranslations } from "../../translations"

const WordsCreated = ({ values }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(6)
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1)
  }

  const { t } = useTranslations()

  const wordsFiltered = values.data?.originalWords.filter(
    (word) => (word.isCreated === 1 || word.isCreated || word.isCreated === "true") && !word.type,
  )
  const currentItems = wordsFiltered?.slice(indexOfFirstItem, indexOfLastItem)

  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <div>
            <h1 className="dashboard-title mb-1">{values.title}</h1>
            <p className="text-muted">{t("words")}</p>
          </div>
        </div>

        <div className="modern-card shadow-sm border-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-4">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="px-4 py-3 border-0 text-muted small text-uppercase fw-bold">#</th>
                  <th scope="col" className="px-4 py-3 border-0 text-muted small text-uppercase fw-bold">{t("spanish")}</th>
                  <th scope="col" className="px-4 py-3 border-0 text-muted small text-uppercase fw-bold">{t("syllables")}</th>
                  <th scope="col" className="px-4 py-3 border-0 text-muted small text-uppercase fw-bold">{t("english")}</th>
                  <th scope="col" className="px-4 py-3 border-0 text-muted small text-uppercase fw-bold">{t("topic")}</th>
                  <th scope="col" className="px-4 py-3 border-0 text-muted small text-uppercase fw-bold text-center">{t("details")}</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && (
                  <Words
                    currentItems={currentItems}
                    itemOffset={indexOfFirstItem}
                    handleImage={values.handleImage}
                    isModule={values.isModule}
                  />
                )}
              </tbody>
            </table>

            <div className="mt-4 d-flex justify-content-center">
              <ReactPaginate
                onPageChange={paginate}
                pageCount={Math.ceil(wordsFiltered?.length / itemsPerPage) || 1}
                previousLabel={t("previous")}
                nextLabel={t("next")}
                containerClassName={"pagination gap-2"}
                pageLinkClassName={"page-link rounded-circle border-0 text-plum fw-bold d-flex align-items-center justify-content-center"}
                previousLinkClassName={"page-link rounded-pill border-0 px-3 fw-bold"}
                nextLinkClassName={"page-link rounded-pill border-0 px-3 fw-bold"}
                activeLinkClassName={"active bg-plum text-white shadow-sm"}
                pageClassName={"page-item"}
                style={{ height: '40px', width: '40px' }}
              />
            </div>
          </div>
        </div>
        <Footer logged={values.logged} />
      </main>

      <style>{`
        .text-plum { color: var(--plum-bg); }
        .bg-plum { background-color: var(--plum-bg); }
        .page-link { 
          color: var(--plum-bg);
          transition: all 0.2s ease;
        }
        .page-link:hover {
          background-color: var(--pastel-pink);
          color: var(--pink-bright);
        }
        .table thead th {
          background-color: #fcfcfc;
          letter-spacing: 1px;
        }
        .table tbody tr:hover {
          background-color: rgba(235, 33, 120, 0.02);
        }
      `}</style>
    </div>
  )
}

export default WordsCreated
